import React, {
  ReactElement,
  createContext,
  useContext,
  useState,
} from 'react';

type OrientationContextType = {
  lockedOrientation: string | null;
  setLockedOrientation: React.Dispatch<React.SetStateAction<string | null>>;
};

const initialOrientationContext: OrientationContextType = {
  lockedOrientation: null,
  setLockedOrientation: () => null,
};

const OrientationContext = createContext<OrientationContextType>(
  initialOrientationContext
);

export const OrientationContextProvider = ({
  children,
}: {
  children?: React.ReactNode;
}): ReactElement => {
  const [lockedOrientation, setLockedOrientation] = useState<string | null>(
    null
  );

  return (
    <OrientationContext.Provider
      value={{ lockedOrientation, setLockedOrientation }}
    >
      {children}
    </OrientationContext.Provider>
  );
};

export const useOrientationContext = (): OrientationContextType =>
  useContext<OrientationContextType>(OrientationContext);
